import { ICaseDecisionService } from "../service/CaseDecisionService";

export default class RevertCaseDecisionStatusInteractor {
  private caseDecisionService: ICaseDecisionService;

  constructor({ caseDecisionService }: any) {
    this.caseDecisionService = caseDecisionService;
  }

  async execute(caseDecisionId: string) {
    return this.caseDecisionService.revertCaseDecisionStatus(caseDecisionId);
  }
}
